import { mapErrors } from "@insightfulscience/shared-utils/fn";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { requestFreeTrial } from "../services/trial";
import getOperationError from "../apollo/operation-errors";
import routes, { toCompleteProfilePage, navToPath } from "../routes";
import { withLoading } from "../nprogress";
import { RefreshToken, Token } from "../persistent-storage";

const navToPathWithSettledTokens = (token, refreshToken, trialId) => {
	Token().set(token);
	RefreshToken().write(refreshToken);
	toCompleteProfilePage(trialId);
};

const navToCompleteProfilePage = (token, refreshToken, trialId) =>
	token && refreshToken
		? navToPathWithSettledTokens(token, refreshToken, trialId)
		: toCompleteProfilePage(trialId);

const handleSuccess = ({ trialId, isAuthorized, token, refreshToken }) =>
	!isAuthorized
		? navToPath(routes.confirmEmail)
		: navToCompleteProfilePage(token, refreshToken, trialId);

/** @type {(form: { email: string }, turingToken: string) => Promise<void>} */
const requestTrial = (form, turingToken) =>
	requestFreeTrial(form, turingToken)
		.then(handleSuccess)
		.catch(mapErrors(getOperationError));

export default pipe(requestTrial, withLoading("request-trial"));
